export async function SendForgotPassword(apiInstance, email) {
  try {
    const response = await apiInstance.post(
      `/User/send-resetpassword-email/${email}`,
    );
    return response;
  } catch (err) {
    if (err.response) {
      return err.response;
    } else {
      throw err;
    }
  }
}

export async function VerifyResetPassword(apiInstance, accessCode, email) {
  try {
    if (!accessCode || !email) {
      return;
    }
    const response = await apiInstance.get(
      `/User/verify-reset-password/${accessCode}/${email}`,
    );
    return response;
  } catch (err) {}
}

export async function ResetPassword(apiInstance, postData) {
  try {
    const response = await apiInstance.put("/user/reset-password/", postData);
    return response;
  } catch (err) {
    throw new Error(`ResetPassword failed: ${err.message}`);
  }
}

export async function ConfirmUserRegistration(
  apiInstance,
  registerCode,
  email,
) {
  try {
    await apiInstance.post(`/User/register/${registerCode}/${email}`);
    return true;
  } catch (err) {
    if (err.response) {
      if (err.response.status === 400) {
        return "Bad request: Invalid registration code or email.";
      } else if (err.response.status === 404) {
        return "Not found: Registration information not found.";
      }
    }
    return false;
  }
}

export async function CheckIsEmailExist(apiInstance, email) {
  try {
    if (!email) {
      return;
    }
    const response = await apiInstance.get(`/User/can-register-email/${email}`);
    return response;
  } catch (err) {}
}
